<template>
	<v-container fluid class="ma-0 pa-0">
		<Header title="Fabric Test" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-10" cols="12">
				<!-- <v-row class="ma-0 pa-0 mb-3" align="center">
					<v-btn width="auto" height="auto" class="ma-0 pa-2" 
						id="blue_btn" elevation="0" @click="canvasClear">
						{{'Clear'}}
					</v-btn>
				</v-row> -->
				<canvas id="c" width="500" height="300" style="border:1px solid #ccc"></canvas>
				<v-col class="ma-0 pa-3" cols="12">
					<v-col class="ma-0 pa-0 pb-2" cols="12" align="left">
						{{ 'cols = ' + canvasWidth + ', rows = ' + canvasHeight}}
					</v-col>
					<v-col class="ma-0 pa-0" cols="12" align="left"
						v-for="(item, index) in objectList" :key="index">
						{{'Object ' + index + ' > ' + 'xmin = ' + item.left + ', xmax = ' + item.width + ', ymin = ' + item.top + ', ymax = ' + item.height}}
					</v-col>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import { fabric } from 'fabric';
import Header from './components/Header.vue';
export default {
	components: {
		Header
	},
	mixins: [mixin.common],
	data: () => ({
		canvasWidth: 0,
		canvasHeight: 0,
		objectList: [],
		thumbnailUrl: '',
	}),
	created() {
		this.thumbnailUrl = this.$route.query.thumbnailUrl;
	},
	mounted() {
		var canvas = new fabric.Canvas('c', {
			selection: false,
		});
		var rect, isDown, origX, origY, bgImage;
		var img = document.createElement('img');
		img.src = require("@/assets/images/delete_icon.png");

		fabric.Object.prototype.transparentCorners = false;

		this.canvasWidth = canvas.width;
		this.canvasHeight = canvas.height;

		fabric.Image.fromURL(this.thumbnailUrl, (backImg) => {
      bgImage = backImg;
			var canvasAspect = this.canvasWidth / this.canvasHeight;
			var imgAspect = bgImage.width / bgImage.height;
			var left, top, scaleFactor;

			if (canvasAspect >= imgAspect) {
				var scaleFactor = this.canvasWidth / bgImage.width;
				left = 0;
				top = -((bgImage.height * scaleFactor) - this.canvasHeight) / 2;
			} else {
				var scaleFactor = this.canvasHeight / bgImage.height;
				top = 0;
				left = -((bgImage.width * scaleFactor) - this.canvasWidth) / 2;
			}

			canvas.setBackgroundImage(this.thumbnailUrl, canvas.renderAll.bind(canvas), {
				// Optionally add an opacity lvl to the image
				backgroundImageOpacity: 1,
				// should the image be resized to fit the container?
				backgroundImageStretch: false,
				width: canvas.width,
				height: canvas.height,
				originX: 'left',
				originY: 'top',
				top: top,
				left: left,
				scaleX: scaleFactor,
				scaleY: scaleFactor,
			});
    });

		canvas.on('mouse:down', function(o){
			if(o.target == null) {
				isDown = true;
				var pointer = canvas.getPointer(o.e);
				origX = pointer.x;
				origY = pointer.y;
				var pointer = canvas.getPointer(o.e);
				rect = new fabric.Rect({
					left: origX,
					top: origY,
					originX: 'left',
					originY: 'top',
					width: pointer.x-origX,
					height: pointer.y-origY,
					angle: 0,
					fill: 'rgba(0,141,208,0.24)',
					stroke: 'rgba(0,141,208,1)',
					strokeWidth: 1,
					transparentCorners: false,
					objectCaching: false,
					lockRotation: true,
					lockScalingX: true,
					lockScalingY: true,
				});
				fabric.Object.prototype.controls.deleteControl = new fabric.Control({
					x: 0.5,
					y: -0.5,
					offsetY: 0,
					cursorStyle: 'pointer',
					mouseUpHandler: (eventData, transform) => {
						var target = transform.target;
						var canvas = target.canvas;
						canvas.remove(target);
						canvas.requestRenderAll();
					},
					render: (ctx, left, top, styleOverride, fabricObject) => {
						var size = 24;
						ctx.save();
						ctx.translate(left, top);
						ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
						ctx.drawImage(img, -size/2, -size/2, size, size);
						ctx.restore();
					},
				});
				// console.log(rect.getBoundingRect());
				if(origX > 0 && origY > 0) {
					canvas.add(rect);
					canvas.setActiveObject(rect);
				}
			}
		});

		canvas.on('mouse:move', function(o){
			if (!isDown) return;
			var pointer = canvas.getPointer(o.e);
			if(origX > pointer.x){
				rect.set({ left: Math.abs(pointer.x) });
			}
			if(origY > pointer.y){
				rect.set({ top: Math.abs(pointer.y) });
			}
			rect.set({ width: Math.abs(origX - pointer.x) });
			rect.set({ height: Math.abs(origY - pointer.y) });
			canvas.renderAll();
		});

		canvas.on('mouse:up', (o) => {
			isDown = false;

			var pointer = canvas.getPointer(o.e);
			// console.log(canvas.getActiveObject());
			// console.log(origX, Math.abs(origX - pointer.x));
			if(origX + Math.abs(origX - pointer.x) > 500 || origY, Math.abs(origY - pointer.y) > 300) {
				canvas.remove(canvas.getActiveObject());
			}

			var json = JSON.stringify(canvas);
			console.log(canvas._objects); // 확인용
			this.makeParams(canvas._objects);
		});

		canvas.on('object:moving', function (e) {
      var obj = e.target;
       // if object is too big ignore
      if(obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width){
          return;
      }        
      obj.setCoords();        
      // top-left  corner
      if(obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0){
          obj.top = Math.max(obj.top, obj.top-obj.getBoundingRect().top);
          obj.left = Math.max(obj.left, obj.left-obj.getBoundingRect().left);
      }
      // bot-right corner
      if(obj.getBoundingRect().top+obj.getBoundingRect().height  > obj.canvas.height || obj.getBoundingRect().left+obj.getBoundingRect().width  > obj.canvas.width){
          obj.top = Math.min(obj.top, obj.canvas.height-obj.getBoundingRect().height+obj.top-obj.getBoundingRect().top);
          obj.left = Math.min(obj.left, obj.canvas.width-obj.getBoundingRect().width+obj.left-obj.getBoundingRect().left);
      }
    });

		setTimeout(() => {
			let objects = [];
			let boxes = [
				{
					xmax: 447,
					xmin: 137,
					ymax: 271,
					ymin: 31
				}
			];
			boxes.forEach((item) => {
				objects.push({
					type: 'rect',
					left: item.xmin,
					top: item.ymin,
					originX: 'left',
					originY: 'top',
					width: item.xmax - item.xmin,
					height: item.ymax - item.ymin,
					angle: 0,
					fill: 'rgba(0,141,208,0.24)',
					stroke: 'rgba(0,141,208,1)',
					strokeWidth: 1,
					transparentCorners: false,
					objectCaching: false,
					lockRotation: true,
					lockScalingX: true,
					lockScalingY: true,
				})
			});

    	fabric.util.enlivenObjects(objects, (objects) => {
				fabric.Object.prototype.controls.deleteControl = new fabric.Control({
					x: 0.5,
					y: -0.5,
					offsetY: 0,
					cursorStyle: 'pointer',
					mouseUpHandler: (eventData, transform) => {
						var target = transform.target;
						var canvas = target.canvas;
						canvas.remove(target);
						canvas.requestRenderAll();
					},
					render: (ctx, left, top, styleOverride, fabricObject) => {
						var size = 24;
						ctx.save();
						ctx.translate(left, top);
						ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
						ctx.drawImage(img, -size/2, -size/2, size, size);
						ctx.restore();
					},
				});
				canvas.add(...objects);
				this.makeParams(canvas._objects);
			});
		}, 2000);

		// var edgedetection = 10; //pixels to snap
		// canvas.on('object:moving', (e) => {
		// 	var obj = e.target;
		// 	// if object is too big ignore
    //   if(obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width){
    //     return;
    //   }        
    //   obj.setCoords();        
    //   // top-left  corner
    //   if(obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0){
    //     obj.top = Math.max(obj.top, obj.top-obj.getBoundingRect().top);
    //     obj.left = Math.max(obj.left, obj.left-obj.getBoundingRect().left);
    //   }
    //   // bot-right corner
    //   if(obj.getBoundingRect().top+obj.getBoundingRect().height  > obj.canvas.height || obj.getBoundingRect().left+obj.getBoundingRect().width  > obj.canvas.width){
    //     obj.top = Math.min(obj.top, obj.canvas.height-obj.getBoundingRect().height+obj.top-obj.getBoundingRect().top);
    //     obj.left = Math.min(obj.left, obj.canvas.width-obj.getBoundingRect().width+obj.left-obj.getBoundingRect().left);
    //   }

		// 	obj.setCoords(); //Sets corner position coordinates based on current angle, width and height
		// 	canvas.forEachObject(function (targ) {
		// 		var activeObject = canvas.getActiveObject();
		// 		if (targ === activeObject) return;
		// 		if (Math.abs(activeObject.oCoords.tr.x - targ.oCoords.tl.x) < edgedetection) {
		// 			activeObject.left = targ.left - activeObject.currentWidth;
		// 		}
		// 		if (Math.abs(activeObject.oCoords.tl.x - targ.oCoords.tr.x) < edgedetection) {
		// 			activeObject.left = targ.left + targ.currentWidth;
		// 		}
		// 		if (Math.abs(activeObject.oCoords.br.y - targ.oCoords.tr.y) < edgedetection) {
		// 			activeObject.top = targ.top - activeObject.currentHeight;
		// 		}
		// 		if (Math.abs(targ.oCoords.br.y - activeObject.oCoords.tr.y) < edgedetection) {
		// 			activeObject.top = targ.top + targ.currentHeight;
		// 		}
		// 		if (activeObject.intersectsWithObject(targ) && targ.intersectsWithObject(activeObject)) {
		// 			targ.strokeWidth = 10;
		// 			targ.stroke = 'red';
		// 		} else {
		// 			targ.strokeWidth = 0;
		// 			targ.stroke = false;
		// 		}
		// 		if (!activeObject.intersectsWithObject(targ)) {
		// 			activeObject.strokeWidth = 0;
		// 			activeObject.stroke = false;
		// 		}
		// 	});
		// });
	},
	methods: {
		makeParams(objectList) {
			this.objectList = [];
			objectList.forEach((object, index) => {
				this.objectList.push(object);
			});
		},
	}
}
</script>

<style lang="scss" scoped>

</style>